import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-procheck-redirect',
  templateUrl: './procheck-redirect.component.html',
  styleUrls: ['./procheck-redirect.component.scss']
})
export class ProcheckRedirectComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  public goToSense(): void {
    window.open('https://sense.adey.com/', '_blank');
  }
}
